module.exports = __webpack_public_path__ + "img/hyperbolic_gmt.e2120db4.gif";